export class MissedLocaleKeyException extends Error {
  public name: string;

  constructor(missedKey: string, currentLocale: string) {
    super(`The message with key ${missedKey} is missing in file ${currentLocale.slice(0, 2)}.json`);
    this.name = 'MissedLocaleKeyException';
  }
}
